var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { selectBalancingFarmEventById, selectBalancingFarmEventIdByEventType, } from "../balancingSelectors/selectBalancingFarmEvents";
import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { selectBalancingQuest } from "../balancingSelectors/selectBalancingQuests";
import { selectResourceAmountInfo, selectResourceInfo, } from "../balancingSelectors/selectBalancingResources";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { ThemedEventConstants } from "../constants/ThemedEventConstants";
import { IdThemedEvent } from "../features/themed-events/IdThemedEvent";
import { mapThemedEventInfo } from "../features/themed-events/mapThemedEventInfo";
import { utilTime } from "../utils/utilTime";
import { selectOutskirtBuildingBundleByBuildingId } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectEventInfo = function (state, id) {
    var result;
    Object.keys(state.eventInfo).some(function (key) {
        var events = state.eventInfo[key];
        if (events != undefined) {
            var event = events.find(function (val) { return val.eventId === id; });
            if (event != undefined) {
                result = {
                    balancing: selectBalancingFarmEventById(event.typeId || -1),
                    proto: event,
                };
                return true;
            }
        }
        return false;
    });
    return result;
};
export var selectRunningEventInfoByTypeId = function (state, typeId) {
    return selectAllEventInfo(state).find(function (event) { return event.proto.typeId === typeId && selectIsEventRunning(event.proto); });
};
export var selectEventInfoByTypeId = function (state, typeId) {
    return selectAllEventInfo(state).find(function (event) { return event.proto.typeId === typeId; });
};
export var selectRunningEventInfosByEventType = function (state, eventType) {
    return selectAllEventInfo(state).filter(function (event) {
        return event.balancing &&
            event.balancing.type &&
            event.balancing.type === eventType &&
            selectIsEventRunning(event.proto);
    });
};
export var selectEventInfosByEventType = function (state, eventType) {
    return selectAllEventInfo(state).find(function (event) { return !!event.balancing && event.balancing.type && event.balancing.type === eventType; });
};
export var selectActiveDiscountEventInfoByEventType = function (state, eventType) {
    var playerLevel = selectPlayerLevel(state);
    return selectRunningEventInfosByEventType(state, eventType)
        .filter(function (event) { return event.balancing.requPlayerLevel <= playerLevel; })
        .shift();
};
export var selectAllEventInfo = function (state) {
    return Object.keys(state.eventInfo).reduce(function (acc, key) {
        var events = state.eventInfo[key];
        if (events != undefined) {
            acc.push.apply(acc, events.map(function (proto) {
                return {
                    balancing: selectBalancingFarmEventById(proto.typeId || -1),
                    proto: proto,
                };
            }));
        }
        return acc;
    }, []);
};
export var selectEventRewards = function (state, currentDifficulty, rewardId) {
    if (rewardId === void 0) { rewardId = 1; }
    var foundReward = currentDifficulty.pointRewards !== undefined
        ? currentDifficulty.pointRewards.find(function (reward) { return reward.pointRewardId === rewardId; })
        : undefined;
    return foundReward !== undefined && foundReward.pointReward !== undefined
        ? foundReward.pointReward
        : [];
};
export var selectEventRewardsResources = function (state, currentDifficulty, rewardId) {
    if (rewardId === void 0) { rewardId = 1; }
    var pointRewards = selectEventRewards(state, currentDifficulty, rewardId);
    return pointRewards.map(function (reward) {
        var requiredThreshold = reward.requiredThreshold, resourceReward = reward.resourceReward;
        var resourceId = resourceReward[0].resourceId;
        var resourceAmount = resourceReward[0].amount;
        return __assign({}, selectResourceAmountInfo(resourceId, resourceAmount), { requiredThreshold: requiredThreshold });
    });
};
export var selectEventTopPrizes = function (state, currentDifficulty) {
    if (currentDifficulty === undefined) {
        return [];
    }
    var prizeResourceReward = currentDifficulty.rankingReward[0].resourceReward;
    return prizeResourceReward.map(function (reward) {
        var resourceId = reward.resourceId;
        return selectResourceInfo(resourceId);
    });
};
export var selectIsEventRunningById = function (state, eventId) {
    var event = selectEventInfoByTypeId(state, eventId);
    if (event == undefined) {
        return false;
    }
    return selectIsEventRunning(event.proto);
};
export var selectIsEventRunningByEventType = function (state, eventType) {
    var typeId = selectBalancingFarmEventIdByEventType(eventType);
    if (typeId == undefined) {
        return false;
    }
    return selectIsEventRunningById(state, typeId);
};
export var selectIsEventRunning = function (event) {
    if (event == undefined) {
        return false;
    }
    var startTime = event.startTime || 0;
    var started = utilTime.secondsLeftTill(startTime) < 0;
    return started && !selectIsEventExpired(event);
};
export var selectIsEventExpired = function (event) {
    if (event === undefined) {
        return false;
    }
    var startTime = event.startTime || 0;
    var duration = event.duration || 0;
    var endTime = startTime + utilTime.secondsToMs(duration);
    var now = utilTime.now();
    return now > endTime;
};
export var selectEventEndTime = function (event) {
    var startTime = event.startTime || 0;
    var duration = event.duration || 0;
    return startTime + utilTime.secondsToMs(duration);
};
export var selectThemedEvent = function (state) {
    var themedEvent = state.eventInfo.themedEvent;
    var isThemedEventActive = themedEvent &&
        themedEvent.length > 0 &&
        themedEvent[0].eventId &&
        // && is supported
        mapThemedEventInfo.has(themedEvent[0].typeId)
        ? selectIsEventRunning(themedEvent[0])
        : false;
    if (!isThemedEventActive) {
        return;
    }
    return themedEvent[0];
};
export var selectThemedEventBuildingName = function (state) {
    var themedEventInfo = selectActiveThemedEventInfo(state);
    return themedEventInfo
        ? themedEventInfo.name
        : mapThemedEventInfo.get(IdThemedEvent.Generic).name;
};
export var selectIsQualifiedForThemedEvent = function (state) {
    var themeEvent = selectThemedEvent(state);
    if (!themeEvent) {
        return false;
    }
    return selectThemedEventPlayerLevelIsEnough(state);
};
export var selectThemedEventPlayerLevelIsEnough = function (state) {
    return selectPlayerLevel(state) >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.ThemedEvent);
};
export var selectIsThemedEventJoined = function (state) {
    var themedEvent = selectThemedEvent(state);
    var player = themedEvent ? themedEvent.player : undefined;
    return !!player;
};
export var selectThemedEventCanPlayerJoin = function (state) {
    return selectIsQualifiedForThemedEvent(state) && !selectIsThemedEventJoined(state);
};
export var selectThemedEventDifficultyLevels = function (state) {
    var themeEvent = selectThemedEvent(state);
    var themedEventBalancing = themeEvent
        ? selectBalancingFarmEventById(themeEvent.typeId || -1)
        : undefined;
    return themedEventBalancing ? themedEventBalancing.difficultyLevel : [];
};
export var selectThemedEventPlayerDifficultyLevel = function (state) {
    var difficultyLevels = selectThemedEventDifficultyLevels(state);
    var activeThemedEvent = selectThemedEvent(state);
    var player = activeThemedEvent ? activeThemedEvent.player : undefined;
    var selectedDifficulyLevelId = player ? player.difficulty : state.themedEventInfo.difficulty;
    return difficultyLevels.find(function (difficulty) { return difficulty.level === selectedDifficulyLevelId; });
};
export var selectThemedEventPlayerDifficultyLevelNumber = function (state) {
    var difficulty = selectThemedEventPlayerDifficultyLevel(state);
    return difficulty ? difficulty.level : 1;
};
export var selectThemedEventActiveQuest = function (state) {
    var timedQuests = state.questInfo.quest.filter(function (quest) { return quest.hasRemainingTime; });
    var activeThemedEvent = selectThemedEvent(state);
    if (activeThemedEvent) {
        var activeQuest = timedQuests.find(function (quest) { return selectBalancingQuest(quest.questId).eventId === activeThemedEvent.typeId; });
        if (activeQuest && activeQuest.questId) {
            return activeQuest;
        }
    }
    return;
};
export var selectThemedEventActiveQuestBalancing = function (state) {
    var activeQuest = selectThemedEventActiveQuest(state);
    if (activeQuest && activeQuest.questId) {
        return selectBalancingQuest(activeQuest.questId) || undefined;
    }
    else if (state.themedEventInfo.quest) {
        return selectBalancingQuest(state.themedEventInfo.quest.questId) || undefined;
    }
    return;
};
export var selectThemedEventTimeRemaining = function (state) {
    var themedEvent = selectThemedEvent(state);
    return themedEvent ? selectEventEndTime(themedEvent) : 0;
};
export var selectThemedEventMaxDifficultyLevel = function (state) {
    return selectThemedEventDifficultyLevels(state).length;
};
export var selectActiveThemedEventInfo = function (state) {
    var themedEvent = selectThemedEvent(state);
    var themedEventTypeId = themedEvent && themedEvent.typeId ? themedEvent.typeId : -1;
    return mapThemedEventInfo.get(themedEventTypeId);
};
export var selectThemedEventDifficultyLevelUnlocked = function (state) {
    var activeThemedEvent = selectThemedEvent(state);
    return activeThemedEvent && activeThemedEvent.maxDifficulty
        ? activeThemedEvent.maxDifficulty
        : 1;
};
export var selectThemedEventIsQuestsCompleted = function (state) {
    var themedEvent = selectThemedEvent(state);
    if (themedEvent && selectIsThemedEventJoined(state)) {
        return !selectThemedEventActiveQuestBalancing(state);
    }
    return false;
};
export var selectThemedEventPlayerReward = function (state) {
    var themedEvent = selectThemedEventPlayerDifficultyLevel(state);
    return themedEvent ? themedEvent.reward : undefined;
};
export var selectIsLastEpisodeInThemedEvent = function (state, questId) {
    var quest = selectBalancingQuest(questId);
    if (quest.eventId && mapThemedEventInfo.get(quest.eventId)) {
        return quest.episode % ThemedEventConstants.eventTotalEpisodes === 0;
    }
    return false;
};
export var selectThemedEventIsRewardCollected = function (state) {
    var themedEvent = selectThemedEvent(state);
    if (themedEvent && themedEvent.player) {
        return !!themedEvent.player.finished;
    }
    return false;
};
export var selectNextThemedEvent = function (state) {
    var themedEvent = state.eventInfo.themedEvent;
    if (themedEvent && themedEvent.length > 0) {
        var currentEvent = themedEvent[0];
        if (!selectIsEventRunning(currentEvent)) {
            return currentEvent;
        }
        return themedEvent.length > 1 ? themedEvent[1] : undefined;
    }
    return;
};
export var selectNextThemedEventBuildingName = function (state) {
    var nextThemedEvent = selectNextThemedEvent(state);
    if (!nextThemedEvent ||
        nextThemedEvent.typeId == undefined ||
        !mapThemedEventInfo.has(nextThemedEvent.typeId)) {
        return mapThemedEventInfo.get(IdThemedEvent.Generic).name;
    }
    return mapThemedEventInfo.get(nextThemedEvent.typeId).name;
};
export var selectThemedEventNextBuildingBundle = function (state) {
    var activeThemedEvent = selectThemedEvent(state);
    var nextThemedEventBuildingName = mapThemedEventInfo.get(IdThemedEvent.Generic).name;
    if (!activeThemedEvent) {
        nextThemedEventBuildingName = selectNextThemedEventBuildingName(state);
    }
    return __assign({}, selectOutskirtBuildingBundleByBuildingId(state, IdOutskirtBuildings.ThemedEvent, 1, true, nextThemedEventBuildingName));
};
export var selectExpiredThemedEventQuest = function (state) {
    var timedQuests = state.questInfo.quest.filter(function (quest) { return quest.hasRemainingTime; });
    if (!timedQuests) {
        return;
    }
    for (var _i = 0, timedQuests_1 = timedQuests; _i < timedQuests_1.length; _i++) {
        var timedQuest = timedQuests_1[_i];
        var questBalancing = selectBalancingQuest(timedQuest.questId);
        if (questBalancing.eventId) {
            var themedEvent = mapThemedEventInfo.get(questBalancing.eventId);
            if (themedEvent) {
                return timedQuest;
            }
        }
    }
    return;
};
export var selectNextThemedEventStartInterval = function (state) {
    var nextThemedEvent = selectNextThemedEvent(state);
    return nextThemedEvent ? nextThemedEvent.startTime - utilTime.now() : undefined;
};
export var selectCoopProjectEventInfo = function (state) {
    var result = [];
    var buffs = state.eventInfo.coopProjectBuff;
    if (buffs) {
        buffs.forEach(function (buff) {
            if (buff.eventId) {
                var buffEventInfo = selectEventInfo(state, buff.eventId);
                if (buffEventInfo) {
                    result.push(buffEventInfo);
                }
            }
        });
    }
    return result;
};
export var selectRunningCoopProjectEventInfo = function (state) {
    var runningEvents = selectCoopProjectEventInfo(state).filter(function (event) {
        return selectIsEventRunning(event.proto);
    });
    return runningEvents ? runningEvents[0] : undefined;
};
export var selectPrimeTimeEventInfo = function (state) {
    var primeTimeEvent = state.eventInfo.primeTimeEvent;
    var playerLevel = selectPlayerLevel(state);
    if (!primeTimeEvent || (primeTimeEvent && primeTimeEvent.length === 0)) {
        return;
    }
    var eventProtoInfo = primeTimeEvent[0];
    if (!selectIsEventRunning(eventProtoInfo)) {
        return;
    }
    var eventBalancingInfo = selectBalancingFarmEventById(eventProtoInfo.typeId);
    if (playerLevel < eventBalancingInfo.requPlayerLevel) {
        return;
    }
    return {
        balancing: eventBalancingInfo,
        proto: eventProtoInfo,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectEventInfo.ts
// module id = 36
// module chunks = 3